import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        scannerSettings: {
            sound: true,
            scanMode: 'camera'
        }
    },
    mutations: {
        SET_SETTING(state, {key, value}) {
            state.scannerSettings[key] = value
        },
        SET_SCAN_MODE(state, mode) {
            state.scannerSettings.scanMode = mode
        }
    },
    actions: {
        changeSetting({commit}, {key, value}) {
            commit('SET_SETTING', {key, value})
        },
        toggleScanMode({commit}, mode) {
            commit('SET_SCAN_MODE', mode)
        }
    },
    modules: {},
    plugins: [createPersistedState()]
})
